import script from "./AssetsDateHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsDateHandler.vue?vue&type=script&setup=true&lang=js"

import "./AssetsDateHandler.vue?vue&type=style&index=0&id=7867549a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7867549a"]])

export default __exports__